import { createSelector } from 'reselect';
import { omit } from '../../../core/util/utils';
import { JobExportParams } from '../../atoms/job-export-params/job-export-params.model';
import * as actions from './job-export.actions';

export interface State {
    params: JobExportParams;
    currentExport: string;
    loading: boolean;
    error: Error;
    downloading: string;
    ids: Array<string>;
    entities: { [id: string]: any };
}

export const initialState: State = {
    params: {
        exportType: 'export',
        fromDate: undefined,
        toDate: undefined,
        dateControl: undefined,
        jobStatuses: [],
        controls: []
    },
    currentExport: undefined,
    loading: false,
    error: undefined,
    downloading: undefined,
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.JobExportActions): State {
    switch (action.type) {
        case actions.SET_PARAMS: {
            return {
                ...state,
                params: action.payload
            };
        }
        case actions.CREATE: {
            return {
                ...state,
                loading: true,
                error: undefined
            };
        }
        case actions.CREATE_SUCCESS: {
            const exportModel = action.payload;
            return {
                ...state,
                currentExport: exportModel.id,
                loading: false,
                error: undefined,
                ids: [...state.ids, exportModel.id],
                entities: {
                    ...state.entities,
                    [exportModel.id]: exportModel
                }
            };
        }
        case actions.CREATE_FAIL: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }
        case actions.DOWNLOAD: {
            return {
                ...state,
                downloading: action.payload.id,
                error: undefined
            };
        }
        case actions.DOWNLOAD_SUCCESS: {
            return {
                ...state,
                downloading: undefined,
                error: undefined
            };
        }
        case actions.DOWNLOAD_FAIL: {
            return {
                ...state,
                downloading: undefined,
                error: action.payload
            };
        }
        case actions.POLL_SUCCESS: {
            const exportModel = action.payload;
            return {
                ...state,
                entities: {
                    ...state.entities,
                    [exportModel.id]: exportModel
                }
            };
        }
        case actions.POLL_FAIL: {
            return {
                ...state,
                error: action.payload
            };
        }
        case actions.LOAD_ALL_SUCCESS: {
            const exportModels = action.payload;
            let entities = {};

            exportModels.forEach(e => {
                entities = {
                    [e.id]: e
                };
            });

            const ids = exportModels.map(e => e.id);

            return {
                ...state,
                ids,
                entities
            };
        }
        case actions.LOAD_ALL_FAIL: {
            return {
                ...state,
                error: action.payload
            };
        }
        case actions.REMOVE: {
            const exportModel = action.payload;
            return {
                ...state,
                ids: state.ids.filter(id => id !== exportModel.id),
                entities: omit(state.entities, exportModel.id)
            };
        }
        case actions.REMOVE_FAIL: {
            return {
                ...state,
                error: action.payload
            };
        }
        default: {
            return state;
        }
    }
}

export class ExportSelectors {
    static state = createSelector(state => state, state => (state as any).jobsExportPage);
    static params = createSelector(ExportSelectors.state, state => state.params);
    static currentExportId = createSelector(ExportSelectors.state, state => state.currentExport);
    static ids = createSelector(ExportSelectors.state, state => state.ids);
    static entities = createSelector(ExportSelectors.state, state => state.entities);
    static exports = createSelector(ExportSelectors.ids, ExportSelectors.entities, (ids, entities) => {
        return ids
            .map(id => entities[id])
            .filter(exportModel => !!exportModel)
            .sort((a, b) => b.serverCreated.localeCompare(a.serverCreated));
    });
    static export = createSelector(ExportSelectors.currentExportId, ExportSelectors.entities, (id, entities) => entities[id]);
    static loading = createSelector(ExportSelectors.state, state => state.loading);
    static error = createSelector(ExportSelectors.state, state => state.error);
    static downloading = createSelector(ExportSelectors.state, state => state.downloading);
}



// WEBPACK FOOTER //
// ./src/app/pages/job-export-page/job-export.reducer.ts